<ion-footer>
  <div class="menu-infos">
    <ion-chip class="ion-margin-bottom" *ngIf="isStaging" color="warning">
      <ion-label color="warning">Homologação</ion-label>
    </ion-chip>
    <span class="menu-info-mb"> {{ appVersion }} </span>
    <span class="menu-info-mb">{{ currentUserEmail || "" }}</span>
    <span class="menu-info-mb">{{ currentUserPlan || "" }}</span>
    <span class="menu-info-mb">{{ deviceName || "N/A" }}</span> 
    <span *ngIf="hasUser && !userStoreService.userIsFreemium()">Validade: {{ currentUserExpiryDate | date:'dd/MM/yyyy' || "" }}</span>
  </div>
</ion-footer>